import Glide from "@glidejs/glide";
const $glide_featured = document.querySelector(".glide--featured");
if ($glide_featured !== null) {
	new Glide($glide_featured, {
		type: "slider",
		startAt: 0,
		perView: 3,
		peek: {
			before: 0,
			after: 150
		},
		breakpoints: {
			780: {
				perView: 1,
				peek: {
					before: 0,
					after: 20
				}
			}
		}
	}).mount();
}

const $glide_global = document.querySelector(".glide--global");
if ($glide_global !== null) {
	new Glide($glide_global, {
		type: "slider",
		startAt: 0,
		perView: 3,
		peek: {
			before: 0,
			after: 150
		},
		breakpoints: {
			780: {
				perView: 1,
				peek: {
					before: 0,
					after: 80
				}
			}
		}
	}).mount();
}

const $glide_full_width = document.querySelector( '.glide--full-width' );

if ( null !== $glide_full_width ) {
	new Glide( $glide_full_width, {
		type: 'slider',
		startAt: 0,
		perView: 1
	} ).mount();
}
